module.exports = __webpack_public_path__ + "images/vkb_kva_bu_geld.png?1a459c2aba63d05c9ccc188deddb9fed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_kva_bu_geld.png
// module id = 2X3e
// module chunks = 0